export enum TipoRetificacao {
  COMPLETA = 'Completa', 
  SIMPLIFICADA = 'Simplificada'
}